import { getCurrentSessionItemPosition } from './taking';
import { getItemByPosition } from './sessionItems';
import { isOneQuestionAtATime } from '../selectors/quizSessions';

// Helpers
function anyActiveSessionItemsHaveCalculators(state) {
  var activeSessionId = state.getIn(['quizSessions', 'activeQuizSessionId']);
  return state.get('sessionItems').some(function (item) {
    return item.get('quizSessionId') === activeSessionId && item.get('calculatorType') !== 'none';
  });
}

// Exports
export function hasVisibleQuestionCalculator(state) {
  if (isOneQuestionAtATime(state)) {
    // If one question at a time, does current question have a calculator?
    var position = getCurrentSessionItemPosition(state);
    var currentQuestion = getItemByPosition(state, position);
    return currentQuestion && currentQuestion.get('calculatorType') !== 'none';
  }
  // If multiple questions at a time, do any have a calculator?
  return anyActiveSessionItemsHaveCalculators(state);
}